export const TAG_PILL_GROUP_ALIGNMENT_LEFT = "left";
export const TAG_PILL_GROUP_ALIGNMENT_RIGHT = "right";

export const TAG_PILL_GROUP_ALIGNMENTS = [TAG_PILL_GROUP_ALIGNMENT_LEFT, TAG_PILL_GROUP_ALIGNMENT_RIGHT] as const;

export const TAG_PILL_GROUP_SORT_ORDER_ALPHABETICAL_ASC = "alphabetically_asc";
export const TAG_PILL_GROUP_SORT_ORDER_ALPHABETICAL_DESC = "alphabetically_desc";
export const TAG_PILL_GROUP_SORT_ORDER_COUNT_ASC = "count_asc";
export const TAG_PILL_GROUP_SORT_ORDER_COUNT_DESC = "count_desc";
export const TAG_PILL_GROUP_SORT_ORDER = [
  TAG_PILL_GROUP_SORT_ORDER_ALPHABETICAL_ASC,
  // TAG_PILL_GROUP_SORT_ORDER_ALPHABETICAL_DESC,
  // TAG_PILL_GROUP_SORT_ORDER_COUNT_ASC,
  TAG_PILL_GROUP_SORT_ORDER_COUNT_DESC
] as const;
